import React, { useState } from 'react';
import FAQItem from './FAQItem';
import './FAQPopup.css';

interface FAQPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const faqData = [
  {
    id: 1,
    question: "How do I record browser interactions?",
    answer: "To record browser interactions, first click the 'Start Live Browser Session' button. You will find yourself in a browser. Navigate to the page and complete all actions (i.e. login) before you are ready to record the action you want to integrate. Then click the 'Start Recording' button. Perform the action you want to record Once you're done, click 'Stop Recording' to save the recording and assign it a unique name which can then be used by the agent to reverse-engineer the task."
  },
  {
    id: 2,
    question: "What are action recordings and how do I use them?",
    answer: "Action recordings contain a record of all network requests made by your browser while you perform an action. They capture request/response headers, bodies, timings, and more. You can create action recordings by recording browser interactions, assign them unique names, and load them into the agent through the dropdown on the top left."
  },
  {
    id: 3,
    question: "How do I begin using the agent?",
    answer: "After loading an action recording, you will receive a confirmatory message indicating it loaded successfully. Then type the action you want integrated (e.g., add an item to a to-do list). The agent will begin the reverse-engineering process."
  },
  {
    id: 4,
    question: "How do I use the endpoint created?",
    answer: "While the agent may provide instructions to you post-endpoint creation, feel free to always look in the 'Routes' page and click 'view' on your selected endpoint to get an example cURL request. You can find the secret key necessary for authentication to use your endpoint by clicking the 'API Keys' button on the top right of your screen."
  },
  {
    id: 5,
    question: "How do I know that my data is secure?",
    answer: "Privacy is a priority for us. All code generated, tested, and executed by the agent that may contain personal data is encrypted when stored. AWS SSE-S3 enables the server-side encryption of every action recording you create as well."
  }
];

const FAQPopup: React.FC<FAQPopupProps> = ({ isOpen, onClose }) => {
  const [expandedItems, setExpandedItems] = useState<number[]>([]);

  const toggleItem = (id: number) => {
    setExpandedItems(prev => 
      prev.includes(id) 
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="faq-backdrop" onClick={onClose} />
      <div className="faq-popup">
        <div className="faq-header">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <button className="faq-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="faq-content">
          {faqData.map(faq => (
            <FAQItem
              key={faq.id}
              question={faq.question}
              answer={faq.answer}
              isExpanded={expandedItems.includes(faq.id)}
              onToggle={() => toggleItem(faq.id)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQPopup;